import { useNavigate } from 'react-router-dom';
import { useMarkets } from '@/hooks/useMarkets';
import { SPORTS } from '@/components/layout/sports';
import { Glyph, SectionHeader } from './MarketCard';
import { groupByFixture } from './fixtures';

/* The Sports tab of the bottom bar: every sport, with how many events it has
   on the board right now. Tapping one opens the filtered board. */
export function SportsPage() {
  const navigate = useNavigate();
  const { data: markets } = useMarkets();
  const events = groupByFixture(markets);
  const countFor = (catId: string, catName: string) =>
    events.filter((e) => {
      const s = e.sport.toLowerCase();
      return s === catId.toLowerCase() || s === catName.toLowerCase() || s.includes(catName.toLowerCase());
    }).length;

  return (
    <div className="flex flex-col gap-6">
      <div>
        <span className="text-[11px] font-semibold uppercase tracking-[0.12em] text-brand-teal">Browse</span>
        <h1 className="font-display font-extrabold text-3xl tracking-[-0.02em] mt-1">Sports &amp; racing</h1>
      </div>
      <div>
        <SectionHeader title="All sports" meta={`${SPORTS.length} categories`} />
        <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3">
          {SPORTS.map((s) => {
            const n = countFor(s.id, s.name);
            return (
              <button
                key={s.id}
                onClick={() => navigate(`/bets?sport=${encodeURIComponent(s.id)}`)}
                className="relative flex flex-col gap-1.5 rounded-2xl border border-white/[0.08] bg-brand-surface/80 p-4 text-left hover:border-white/20 transition"
              >
                {s.live && <span className="absolute top-3 right-3 w-2 h-2 rounded-full bg-red-400" />}
                <span className="w-9 h-9 rounded-xl grid place-items-center bg-brand-teal/10 text-brand-teal"><Glyph icon={s.icon} size={20} /></span>
                <span className="font-semibold text-sm mt-1">{s.name}</span>
                <span className="text-xs text-white/40">{n} {n === 1 ? 'event' : 'events'}{s.live ? ' · live' : ''}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
